import React from 'react';

import EmailIcon from '@mui/icons-material/Email';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import PersonIcon from '@mui/icons-material/Person';
import Box from '@mui/material/Box';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';

const ParticipantsListItem = ({ text, icon, customSX = {} }) => {
  return (
    <Box display={'flex'} alignItems={'center'} gap={1} m={0} p={0} flex={1}>
      {icon}
      <Typography sx={{ ...customSX }}>{text}</Typography>
    </Box>
  );
};

const ParticipantsList = ({
  participants,
  selectedParticipants,
  handleChange,
  bookingPersonNotParticipate
}) => {
  return (
    <Box>
      {participants.map((participant, index) => (
        <Paper key={participant.id} sx={{ padding: '0.6rem', marginBottom: '0.3rem' }}>
          <FormControlLabel
            key={participant.id}
            sx={{
              width: '100%',
              '.MuiFormControlLabel-label': {
                flex: 1
              }
            }}
            control={
              <Checkbox
                sx={{ margin: '0 1rem' }}
                checked={selectedParticipants.includes(participant.id)}
                onChange={() => handleChange(participant.id)}
                disabled={index === 0 && !bookingPersonNotParticipate}
              />
            }
            label={
              <Box
                sx={{
                  display: 'flex',
                  flexWrap: 'wrap',
                  alignItems: 'center',
                  gap: 2,
                  justifyContent: 'space-between',
                  width: '100%'
                }}
              >
                <ParticipantsListItem
                  text={`${participant?.generalInformation?.firstName} ${participant?.generalInformation?.lastName}`}
                  icon={<PersonIcon fontSize='medium' />}
                  customSX={{ fontWeight: 'bold' }}
                />
                <ParticipantsListItem
                  text={participant?.contactInformation?.email}
                  icon={<EmailIcon fontSize='medium' />}
                />
                <ParticipantsListItem
                  text={participant?.contactInformation?.mobile}
                  icon={<LocalPhoneIcon fontSize='medium' />}
                />
              </Box>
            }
          />
        </Paper>
      ))}
    </Box>
  );
};

export default ParticipantsList;
